import type { FaireProductEntity } from "../../entity_types/product";

export const p_c2948cbf8r: FaireProductEntity = {
  token: "p_c2948cbf8r",
  type: "product",
  name: "14K White Gold Lab Grown Diamond Oval Engagement Ring",
  brandToken: "b_6nzzuc6eex",
  brandName: "Fine Diamond",
  imageUrl:
    "https://cdn.faire.com/fastly/f6a5a82184e9d0a2e1d8546158b787aad489ad852cbc283b1f70dadd0083e57d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a73e0aceb22b908c374750e061fff337a219416e1ef026268f2ed003b05af941.jpeg",
    "https://cdn.faire.com/fastly/fac40d3dac2a5e45e226b743b50dc0a2c46ca1a2df071a6431433969d418dccb.jpeg",
    "https://cdn.faire.com/fastly/84b9b8760cc638280df2a19f996177f6ce782c2a9a3f4301155b8e530f8caa13.jpeg",
    "https://cdn.faire.com/fastly/8b893b1a696789cb5fe4f45984eb546d0340e8e0cf24b2c23c6e68ab0068f5e2.jpeg",
  ],
  priceDollars: 3544.58,
  description:
    "14K White Gold Oval Lab Grown Diamond Engagement Ring for Women\n\nThis breathtaking Oval Diamond Engagement Ring crafted in solid 14K white gold captures the essence of modern romance and refined craftsmanship. With its smooth rhodium-plated silver tone finish, the ring gleams with sophistication, offering exceptional durability and a polished shine that lasts. The band weighs 3.45 grams, designed with a >1.65 mm thickness and a ring top width of 7.85 mm for a luxurious yet comfortable fit. Made for women who cherish beauty and meaning, this lab diamond engagement ring showcases a captivating 4.516-carat total diamond weight, meticulously cast to perfection. Its oval (4-prong) head design enhances the brilliance of the centerpiece while allowing light to flow through each facet effortlessly. Available in sizes 6–8 and sizeable, it’s ideal for everyday elegance or celebrating life’s most significant moments. You can also explore our collection to find pieces that match your style.\n\nAttribute Value \nProduct Type Jewelry \nJewelry Type Rings \nRing Type Engagement \nMaterial: Primary Gold \nMaterial: Color White \nMaterial: Purity 14K \nPlating Rhodium \n",
  tags: [],
  msrpDollars: 17722.89,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:44:43.643Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
